import { render, staticRenderFns } from "./Txoollibros.vue?vue&type=template&id=4a2cda80&scoped=true&"
import script from "./Txoollibros.vue?vue&type=script&lang=js&"
export * from "./Txoollibros.vue?vue&type=script&lang=js&"
import style0 from "./Txoollibros.vue?vue&type=style&index=0&id=4a2cda80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2cda80",
  null
  
)

export default component.exports